/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.6"
        height="16.36"
        viewBox="0 0 19.6 16.36"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 16.36h19.6L9.77 0Zm17.83-1H1.76L9.78 2ZM9.21 6.23h1v4.47h-1Zm.54 7.16a.84.84 0 0 0 .83-.84.83.83 0 0 0-.83-.83.84.84 0 0 0-.84.83.85.85 0 0 0 .84.84Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'TriangleWithExclamationPointIcon';

export default Icon;
